import { defineInlineAdSlotSchema } from "scmp-app/components/schema-render/common/inline-ad-slot/schemas";
import { defineTrackViewedPercentageSchema } from "scmp-app/components/schema-render/common/track-viewed-percentage/schemas";

export const MobileInlineAdTestPlanReadMoreElements = 6;
export const ReadMoreElements = 5;

// Single device-agnostic structure: mobile/tablet slots keep tags "0".."7",
// desktop slots use "d0".."d7". The renderer picks a family on the client so the
// SSR payload (and its cache) never depends on the visitor's device.
export const DefaultCustomContents = [
  defineTrackViewedPercentageSchema({
    percentage: "0",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "20",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "50",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "90",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "100",
  }),
  { row: 12, type: "inline-plus-widget" },
  // mobile/tablet slots
  defineInlineAdSlotSchema({ row: 2, tag: "0" }),
  defineInlineAdSlotSchema({ row: 4, tag: "1" }),
  defineInlineAdSlotSchema({ row: 6, tag: "2" }),
  defineInlineAdSlotSchema({ row: 8, tag: "3" }),
  defineInlineAdSlotSchema({ row: 12, tag: "4" }),
  defineInlineAdSlotSchema({ row: 16, tag: "5" }),
  defineInlineAdSlotSchema({ row: 20, tag: "6" }),
  defineInlineAdSlotSchema({ row: 24, tag: "7" }),
  defineInlineAdSlotSchema({ infiniteAdsAfterNumber: "4", row: 28, tag: "8" }),
  defineInlineAdSlotSchema({ row: -1, tag: "9" }),
  // desktop slots
  defineInlineAdSlotSchema({ row: 3, tag: "d1" }),
  defineInlineAdSlotSchema({ row: -1, tag: "d7" }),
];

export const PrintCustomContents = [
  defineTrackViewedPercentageSchema({
    percentage: "0",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "20",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "50",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "100",
  }),
];
